import { Subscription } from 'rxjs';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IntegrationCode } from 'src/lib/fliko/enums/integrationCode';
import { EstateType } from 'src/lib/fliko/models/estate/estate.data';
import { NoteType } from 'src/lib/fliko/models/notes/notes.data';
import { ResidentType } from 'src/lib/fliko/models/person/resident.data';
import { ParkingData } from 'src/lib/fliko/models/units/parking.data';
import { StorageData } from 'src/lib/fliko/models/units/storage.data';
import { RentalUnitType } from 'src/lib/fliko/models/units/unit.data';
import { GrammarHelper } from 'src/app/shared/helpers/grammar.helper';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';
import { UserCommList } from '../../../services/models/users-table.data';
import { RentalUnitVM, UnitResidentViewModel } from '../../../services/models/users-view-models';
import { UsersCommDataService } from '../../../services/users-comm-data.service';

@Component({
  selector: 'app-users-comm-parking-storage-details',
  templateUrl: './users-comm-parking-storage-details.component.html',
  styleUrls: ['./users-comm-parking-storage-details.component.scss']
})
export class UsersCommParkingStorageDetailsComponent implements OnInit, OnDestroy {
  public parking?: ParkingData;
  public storage?: StorageData;
  public apartment?: RentalUnitVM;

  public typeHR: string;
  public bankAccount: string = '';
  public residents: UnitResidentViewModel[] = [];

  public canEdit = false;
  public showUnitCodes = false;

  private subscription$ = new Subscription();

  NoteType = NoteType;
  EstateType = EstateType;
  RentalUnitType = RentalUnitType;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UserCommList.ParkingStorageElement,
    private dialogRef: MatDialogRef<UsersCommParkingStorageDetailsComponent>,
    private router: Router,
    private userCommData: UsersCommDataService,
    private ls: LocalizationService,
    private ctxDS: ContextDataService
  ) {
    this.typeHR = GrammarHelper.unitTypeHR(data.type, EstateType.COMMUNITY, this.ls);

    switch (data.type) {
      case RentalUnitType.PARKING:
        this.parking = data.unit as ParkingData;
        break;
      case RentalUnitType.STORAGE:
        this.storage = data.unit as StorageData;
        break;
    }

    this.apartment = data.apartment
      ? {
          id: data.apartment.id,
          type: RentalUnitType.APARTMENT,
          unit: data.apartment,
          unitCode: IntegrationCode.fromIntegrationCode(data.apartment.unitCodes)
        }
      : undefined;
  }

  ngOnInit(): void {
    this.subscription$.add(
      this.userCommData.getUnitsResidencyData$(this.data.type, [this.data.id]).subscribe((unitData) => {
        const unit = unitData[0];
        if (unit) {
          this.bankAccount = unit.bankAccount;
          this.residents = unit.residents.filter((r) => r.type == ResidentType.LANDLORD || !!r.currentTenancies?.length);
        }
      })
    );

    this.subscription$.add(
      this.ctxDS.contextPerms$.subscribe((perms) => (this.canEdit = perms?.superAdmin || !!perms?.ePerm?.user?.edit))
    );
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  public onEdit(): void {
    if (!this.canEdit) return;
    this.router.navigate([`/users/${this.data.type}s/edit`, this.data.unit.id]);
    this.dialogRef.close();
  }
}
